import moment from 'moment';
import { request } from '../../requests';
export default {
  namespaced: true,
  state: {
    project: {
      result: {},
      loading: false,
      timestamp: null
    },
    errors: {}
  },
  actions: {
    fetchSchedule({
      commit
    }, {
      projectID
    }) {
      const url = `/tables/projects/${projectID}/schedule`;
      const method = 'GET';
      commit('setProjectLoading', true);
      return request({
        url,
        method
      }).done(responseData => {
        commit('setProjectResult', responseData.result);
        commit('setProjectTimestamp', moment());
      }).always(() => {
        commit('setProjectLoading', false);
      });
    },
    submitSchedule({
      commit
    }, {
      projectID
    }) {
      const url = `/forms/schedule/${projectID}/submit`;
      return request({
        url
      });
    }
  },
  getters: {
    project(state) {
      return state.project.result;
    },
    loading(state) {
      return state.project.loading;
    },
    errors(state) {
      return state.errors;
    }
  },
  mutations: {
    setProjectResult(state, result) {
      return state.project.result = result;
    },
    setProjectLoading(state, loading) {
      return state.project.loading = loading;
    },
    setProjectTimestamp(state, timestamp) {
      return state.project.timestamp = timestamp;
    },
    errors(state, obj) {
      return state.errors = obj;
    }
  }
};